import exhibitors from './exhibitors/es';
import visitors from './visitors/es';
import managers from './managers/es';

export default {
  exhibitors,
  visitors,
  managers,
};
